import { Text } from "@fluentui/react-components";
import { showTranslated, translate } from "@/config/translator";
import { CalendarEntry } from "@/api/openapi";
import { useContext } from "react";
import { PspContext } from "@/config/contexts";
import { formatDateFromLang } from "@/config/utils";

export function CalendarDetailsText({
  selectedCalendarEntries,
  selectedDate,
}: {
  selectedCalendarEntries: CalendarEntry[] | null;
  selectedDate: Date | null;
}) {
  // -----------------------------------------------------------------------------
  // GENERAL
  // -----------------------------------------------------------------------------
  const { lang } = useContext(PspContext);

  return (
    <div className="flex flex-col gap-6">
      <Text weight="medium" size={400}>
        {selectedCalendarEntries === null
          ? translate("eventDetails", lang)
          : formatDateFromLang(
              new Date(selectedCalendarEntries[0]?.date ?? selectedDate),
              lang,
            )}
      </Text>
      {selectedCalendarEntries === null ? (
        <Text className="text-font-secondary" size={200}>
          {translate("noEventSelected", lang)}
        </Text>
      ) : selectedCalendarEntries.length === 0 && selectedDate ? (
        <Text className="text-font-secondary" size={300}>
          {translate("noEventOn", lang)}
        </Text>
      ) : (
        <>
          {selectedCalendarEntries.map((calendarEntry) => (
            <div className="flex flex-row gap-3">
              <div className="w-0.75 rounded-full self-stretch bg-primary" />
              <div className="py-0.5">
                <Text
                  key={`calendar-entry-details-${calendarEntry.id}`}
                  className="text-font"
                >
                  {showTranslated(calendarEntry.text, lang).length === 0 &&
                  lang === "en" ? (
                    <>
                      <Text className="text-disabled">
                        No translation available for this message in english:
                      </Text>
                      <br />
                      {showTranslated(calendarEntry.text, "de")}
                    </>
                  ) : (
                    showTranslated(calendarEntry.text, lang)
                  )}
                </Text>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
